import React, { useEffect, useState } from "react";

export default function OnCallSchedule({ isExpanded = false }) {
  const [schedule, setSchedule] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isExpanded) {
      return undefined;
    }

    let isMounted = true;
    setIsLoading(true);
    setError("");

    const loadSchedule = async () => {
      try {
        const response = await fetch("/.netlify/functions/on-call-schedule", {
          cache: "no-store",
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.error || "Unable to load on-call schedule.");
        }

        if (isMounted) {
          setSchedule(data);
          setError("");
        }
      } catch (loadError) {
        if (isMounted) {
          setSchedule(null);
          setError(
            loadError.message ||
              "Unable to load on-call schedule. Please try again later.",
          );
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadSchedule();

    return () => {
      isMounted = false;
    };
  }, [isExpanded]);

  if (!isExpanded) {
    return null;
  }

  if (isLoading) {
    return <p>Loading on-call schedule...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!schedule?.current && !schedule?.upcoming) {
    return <p>No on-call schedule is available right now.</p>;
  }

  const upcomingLabel = "Upcoming Weekend On Call:";

  return (
    <div>
      <p>
        Weekend on-call begins Friday at 5:00 PM until Sunday at 9:00 PM. For
        Holidays, this time is extended for that day. <br />
        Contact{" "}
        <a href="mailto:on.broker@exprealty.net">on.broker@exprealty.net</a> for
        documents requiring Managing Broker signature outside regular office
        hours.
      </p>
      <br />
      {schedule.current ? (
        <p>
          <strong>Current on call:</strong> {schedule.current.name}
          <br />
          Starting {schedule.current.startDisplay}
        </p>
      ) : null}
      {schedule.upcoming ? (
        <p>
          <strong>{upcomingLabel}</strong> {schedule.upcoming.name}
          <br />
          Starting {schedule.upcoming.startDisplay}
        </p>
      ) : null}
      {schedule.calendarName ? (
        <>
          <br />
          <p style={{ fontSize: "13px", color: "#666" }}>
            Calendar: {schedule.calendarName}
          </p>
        </>
      ) : null}
    </div>
  );
}
